// extracted by css-extract-rspack-plugin
export default {"cardGridFrame":"FeaturedContent-module__cardGridFrame__z6N66"};